import { render, staticRenderFns } from "./HomeProductView.vue?vue&type=template&id=6f45af67&scoped=true"
import script from "./HomeProductView.vue?vue&type=script&lang=js"
export * from "./HomeProductView.vue?vue&type=script&lang=js"
import style0 from "./HomeProductView.vue?vue&type=style&index=0&id=6f45af67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f45af67",
  null
  
)

export default component.exports